export default __webpack_public_path__ + "static/media/carousel-account-info.7c668677.jpg";